import {
  Http
} from '../utils/http.js';
class Customer extends Http {
  addUserLike(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/AddUserLike",
      method: "post",
      param: param
    })
  }
  customerCredit(param){
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/GetCustomerCredit",
      method: "post",
      param: param
    })
  }
}
export {
  Customer
}